<template>
  <ValidationObserver
    ref="observer"
  >
    <NetworkInfos
      v-if="model"
      :networkInfos="model.networkInfos"
      @sendData="updateData"
    />
  </ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import NetworkInfos from '@/components/forms/technicalFile/network/forms/NetworkInfos';
import lockService from '@/utilities/lockService';

export default {
    components: {
        ValidationObserver,
        NetworkInfos,
    },
    props: {
        node: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            empty: {
                networkInfos: {
                    note: '',
                    files: [],
                },
            },
            data: {
                nodeInfo: null,
            },
            model: null,
        };
    },
    computed: {
        ...mapGetters([
            'site',
            'userLang',
            'hasPermission',
        ]),
        readonly() {
            return !this.hasPermission('techFiles.edit');
        },
    },
    mounted() {
        window.addEventListener('beforeunload', this.handleUnload);
    },
    async created() {
        this.loading = true;
        await this.getNodeInfo();
        this.model = this.data.nodeInfo ? this.data.nodeInfo : this.empty;
        this.loading = false;
        this.$store.dispatch('clearTabs');
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.handleUnload);
        if (this.node && this.node.ref) {
            lockService.releaseLock(this.node.ref, 'TechnicalFileNetwork');
        }
    },
    methods: {
        async getNodeInfo() {
            const { data } = await this.$rq.getNodeInfo(this.site.id, this.node.ref);
            if (Object.keys(data).length) this.data.nodeInfo = data;
        },
        updateData(newData) {
            this.model = { ...this.model, ...newData };
            this.$emit('sendData', this.model);
        },
        handleUnload() {
            if (this.node && this.node.ref) {
                lockService.releaseLock(this.node.ref, 'TechnicalFileNetwork');
            }
        },
    },
};
</script>
